export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "吃瓜视频是做什么的？",
    a: "吃瓜视频是一个专注娱乐八卦的瓜料分类聚合站，把娱乐八卦、明星爆料、社会事件、网红日常、搞笑合集与实拍现场等内容按主题分类整理，让你想找哪类瓜直接进对应分类，省时省力、吃瓜不迷路。",
  },
  {
    q: "内容多久更新一次？",
    a: "我们保持每日高频更新，聚合全网热门瓜料与热点动态，分类栏与热榜实时刷新，方便你第一时间掌握娱乐八卦、明星爆料和社会热点等新鲜内容。",
  },
  {
    q: "如何更快找到我想看的瓜？",
    a: "你可以在站内使用顶部搜索直接输入关键词，也可以通过首页的六大分类入口或热搜词进入对应主题，分类筛选与关键词检索双管齐下，能明显提升找瓜效率。",
  },
  {
    q: "内容来源与呈现方式是什么？",
    a: "站内内容以视频为主，辅以图文盘点与专题。我们坚持客观呈现，整理信息时会注明来源方向并保持中立，避免断章取义与不实描述。",
  },
  {
    q: "会发布未经核实的内容吗？",
    a: "不会。我们对存疑、待证实的信息会标注「网传待核实」等提示，不渲染未经证实的猜测，也希望网友理性吃瓜、谨慎转发，让信息环境更干净。",
  },
  {
    q: "怎样反馈或提出想看的内容？",
    a: "欢迎通过页脚的站内反馈告诉我们你想看的话题，或补充更多背景线索。你的建议会直接帮助我们改进分类与更新方向。",
  },
];